/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineScope {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return TagBaselineScope.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineScope>): TagBaselineScope {
        let obj = Object.assign(new TagBaselineScope(), model);
        TagBaselineScope.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineScope>): TagBaselineScope {
        if (!model) return null;
        return TagBaselineScope.newInstance(<TagBaselineScope> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineScope) {
        if (!obj) return;

        models.TagBaselineScope.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineScope): boolean {
        switch (obj.__type)
        {
            case "TagBaselineScopeCloudAccount":
                Object.setPrototypeOf(obj, models.TagBaselineScopeCloudAccount.prototype);
                break;
            case "TagBaselineScopeGlobal":
                Object.setPrototypeOf(obj, models.TagBaselineScopeGlobal.prototype);
                break;
            case "TagBaselineScopeTenant":
                Object.setPrototypeOf(obj, models.TagBaselineScopeTenant.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof TagBaselineScope)[] {
        return [
            models.TagBaselineScopeCloudAccount,
            models.TagBaselineScopeGlobal,
            models.TagBaselineScopeTenant,
        ];
    }

    fixupFields() {
    }

    /**
     * Allow inheriting rules from parent scope
     */
    inherit: boolean;

}
